
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bestcabserviceforcorporateemployeepune() {



    const cardData =
    {
        keyword: 'Best Cab Service for Corporate Employees Pune  ',
        heading: 'etravo : Best Cab Service for Corporate Employees Pune  ',



"headingDescription": "eTravo offers one of the Best Cab Services for Corporate Employees in Pune, designed to ensure safe, punctual, and comfortable daily commuting for professionals working in IT parks, corporate offices, and industrial zones. With a modern fleet of GPS-enabled vehicles, trained chauffeurs, and customized routing, eTravo provides reliable employee transportation solutions including daily office pickup and drop, shift-based travel, and monthly corporate contracts across Pune.",

"top": "Top Corporate Employee Travel Zones in Pune with eTravo",

"topPlaces": [
  {
    "title": "Hinjewadi IT Park",
    "description": "Pune’s largest IT hub with thousands of employees commuting daily, requiring structured and scalable corporate cab services."
  },
  {
    "title": "Kharadi IT Park",
    "description": "A fast-growing corporate district with IT companies and MNCs, making employee transport essential for smooth operations."
  },
  {
    "title": "Magarpatta City",
    "description": "A self-contained IT township with Cybercity offices, ideal for organized and reliable employee commute services."
  },
  {
    "title": "Hadapsar IT & Industrial Zone",
    "description": "Home to SP Infocity and multiple corporate offices requiring daily pickup and drop services for employees."
  },
  {
    "title": "Baner",
    "description": "A growing IT and startup hub where professionals rely heavily on daily office transportation services."
  },
  {
    "title": "Wakad",
    "description": "A major residential base for IT employees working in Hinjewadi, requiring consistent and timely cab services."
  },
  {
    "title": "Viman Nagar",
    "description": "A premium residential and corporate area near the airport, supporting executive and employee travel needs."
  },
  {
    "title": "Koregaon Park",
    "description": "A high-end business locality with offices and consulting firms requiring reliable employee transport solutions."
  },
  {
    "title": "Shivajinagar",
    "description": "A central business district with government and corporate offices needing daily commuting support."
  },
  {
    "title": "Pimpri-Chinchwad",
    "description": "A major industrial and IT corridor with large-scale workforce movement requiring structured transport services."
  }
],


"services": [
{
"name": "Best Corporate Cab Pune",
"description": "eTravo is known for providing the best corporate cab services in Pune, offering reliable and professional transportation for businesses. Our service ensures punctual pickups, comfortable rides, and experienced chauffeurs, making daily corporate travel smooth and hassle-free."
},
{
"name": "Top Employee Transport Pune",
"description": "Our top employee transport services in Pune are designed for safe and efficient workforce mobility. eTravo ensures structured routes, timely pickups, and comfortable vehicles to support daily employee commuting."
},
{
"name": "Corporate Taxi Service Pune",
"description": "eTravo offers corporate taxi services in Pune tailored for business travel needs. Whether it’s meetings, airport transfers, or daily commuting, our taxis provide reliable and professional transportation."
},
{
"name": "Best Office Cab Pune",
"description": "Simplify your daily commute with the best office cab services in Pune by eTravo. Our service ensures timely pickups, safe travel, and comfortable rides for employees traveling to and from work."
},
{
"name": "Reliable Corporate Cab Pune",
"description": "eTravo provides reliable corporate cab services in Pune with a focus on punctuality and consistency. Our well-maintained vehicles and trained drivers ensure smooth and dependable travel for businesses."
},
{
"name": "Employee Pickup Drop Pune",
"description": "Our employee pickup and drop services in Pune are designed for convenience and safety. eTravo ensures well-coordinated schedules and comfortable rides, helping employees reach their workplace on time."
},
{
"name": "Professional Cab Service Pune",
"description": "eTravo’s professional cab services in Pune are built to meet high corporate standards. With experienced drivers and clean vehicles, we ensure every journey is comfortable, safe, and efficient."
},
{
"name": "Corporate Travel Pune",
"description": "eTravo offers complete corporate travel services in Pune, covering local and outstation needs. Our service ensures smooth travel for executives and employees with a focus on reliability and comfort."
},
{
"name": "Company Cab Service Pune",
"description": "Our company cab services in Pune provide customized transportation solutions for businesses. From employee transport to executive travel, eTravo ensures flexibility, reliability, and professional service."
},
{
"name": "Staff Transport Pune",
"description": "eTravo offers dependable staff transport services in Pune for daily commuting. Our service ensures punctual pickups, safe travel, and smooth coordination for workforce mobility."
},
{
"name": "Executive Cab Pune",
"description": "Experience premium travel with eTravo’s executive cab services in Pune. Designed for senior management and VIP clients, our vehicles provide comfort, privacy, and professional service."
},
{
"name": "Best Taxi for Office Pune",
"description": "eTravo provides the best taxi services for office travel in Pune with a focus on comfort and punctuality. Our service ensures reliable daily commuting for professionals across the city."
},
{
"name": "Corporate Commute Service Pune",
"description": "Our corporate commute services in Pune are designed for efficient and structured employee transportation. eTravo ensures smooth daily travel with reliable vehicles and trained drivers."
},
{
"name": "Trusted Cab Service Pune",
"description": "eTravo is a trusted cab service provider in Pune known for its reliability and professionalism. We ensure safe, timely, and comfortable travel for all corporate and individual needs."
},
{
"name": "Business Travel Cab Pune",
"description": "eTravo offers business travel cab services in Pune for meetings, site visits, and corporate trips. Our service ensures smooth and efficient travel with a focus on comfort and punctuality."
}
],
"tableData": [
["Best Corporate Cab Pune", "Top Employee Transport Pune"],
["Corporate Taxi Service Pune", "Best Office Cab Pune"],
["Reliable Corporate Cab Pune", "Employee Pickup Drop Pune"],
["Professional Cab Service Pune", "Corporate Travel Pune"],
["Company Cab Service Pune", "Staff Transport Pune"],
["Executive Cab Pune", "Best Taxi for Office Pune"],
["Corporate Commute Service Pune", "Trusted Cab Service Pune"],
["Business Travel Cab Pune", ""]
],





"whychoose": [
    {
      "WhyChooseheading": "Best Cab Service for Corporate Employees in Pune",
      "WhyChoosedescription": "eTravo delivers top-rated cab service for corporate employees in Pune, ensuring reliable, safe, and professional transportation across major business hubs like Hinjewadi, Kharadi, Baner, and Magarpatta."
    },
    {
      "WhyChooseheading": "Boosts Employee Productivity and Efficiency",
      "WhyChoosedescription": "With structured pickup and drop services, employees avoid travel stress and delays, allowing them to stay focused and productive throughout the workday. :contentReference[oaicite:0]{index=0}"
    },
    {
      "WhyChooseheading": "Punctual and Hassle-Free Daily Commute",
      "WhyChoosedescription": "Fixed schedules and optimized routes ensure employees reach offices on time, reducing absenteeism and improving overall business performance. :contentReference[oaicite:1]{index=1}"
    },
    {
      "WhyChooseheading": "Safe and Secure Travel for Employees",
      "WhyChoosedescription": "Our cab services include GPS tracking, verified drivers, and safety protocols, ensuring a secure travel environment for employees, including late-night shifts."
    },
    {
      "WhyChooseheading": "Wide Fleet for Every Corporate Requirement",
      "WhyChoosedescription": "From sedans to SUVs and executive vehicles, eTravo offers a versatile fleet suitable for daily office commute, meetings, and corporate travel needs."
    },
    {
      "WhyChooseheading": "Flexible Plans for Corporate Employees",
      "WhyChoosedescription": "We provide daily, monthly, and contract-based transportation plans that adapt to company size, shift timings, and employee locations."
    },
    {
      "WhyChooseheading": "Cost-Effective Corporate Transport Solution",
      "WhyChoosedescription": "Structured pricing and centralized billing reduce travel costs compared to ad-hoc taxi bookings while improving operational efficiency. :contentReference[oaicite:2]{index=2}"
    },
    {
      "WhyChooseheading": "24/7 Support and Real-Time Assistance",
      "WhyChoosedescription": "Our support team ensures smooth coordination, quick issue resolution, and uninterrupted service for all corporate employee travel requirements."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What is the best cab service for corporate employees in Pune?',
            answer: 'The best cab service offers reliable pickup and drop, professional drivers, safety features, and flexible plans tailored for corporate employee transportation.',
        },
        {
            question: 'Why do companies provide cab services to employees?',
            answer: 'Companies provide cab services to improve employee punctuality, reduce commute stress, and increase productivity and job satisfaction. :contentReference[oaicite:3]{index=3}',
        },
        {
            question: 'Are corporate cab services safe for employees?',
            answer: 'Yes, corporate cab services include GPS tracking, verified drivers, and safety protocols to ensure secure travel for employees.',
        },
        {
            question: 'Can cab services support night shift employees in Pune?',
            answer: 'Yes, corporate cab services operate 24/7 and are specially designed to support night and rotational shift employees.',
        },
        {
            question: 'Do corporate cab services reduce travel costs for companies?',
            answer: 'Yes, structured pricing and bulk booking options help companies manage and reduce transportation expenses effectively. :contentReference[oaicite:4]{index=4}',
        },
        {
            question: 'What types of vehicles are available for corporate employees?',
            answer: 'Corporate cab fleets include hatchbacks, sedans, SUVs, and luxury vehicles depending on employee and executive travel needs.',
        },
        {
            question: 'Can companies customize employee transport routes?',
            answer: 'Yes, routes and schedules can be customized based on employee locations and company requirements.',
        },
        {
            question: 'Is daily office pickup and drop included in corporate cab services?',
            answer: 'Yes, most corporate cab services include daily office pickup and drop as a core offering.',
        },
        {
            question: 'Do corporate cab services provide real-time tracking?',
            answer: 'Yes, GPS-enabled tracking allows companies and employees to monitor rides in real time.',
        },
        {
            question: 'How can I book the best cab service for corporate employees in Pune?',
            answer: 'You can book through service provider websites or contact their support team for customized corporate transport solutions.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Deepak Kulkarni',
        designation: 'Operations Manager, IT Company, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo provides the best cab service for our corporate employees in Pune. Their punctuality and safety features have significantly improved our daily operations.”',
    },
    {
        name: 'Ms. Shreya Patil',
        designation: 'HR Manager, Tech Firm, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We trust eTravo for employee transportation. Their reliable service and flexible plans ensure a smooth and stress-free commute for our team.”',
    },
];










    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Cab Service for Corporate Employees Pune",
  "image": "https://www.etravo.in/images/keyword/best-corporate-cab-pune.jpg",
  "description": "Trusted and reliable corporate cab service in Pune by eTravo. Ideal for employee pickup and drop, office commute, executive travel, and business transportation with safe and professional service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/best-cab-service-for-corporate-employees-pune"
  }
};






    return (
        <div>


<Helmet>
  <title>Best Cab Service for Corporate Employees Pune | Reliable Office Transport | eTravo</title>
  <meta 
    name="description" 
    content="Choose the best cab service for corporate employees in Pune with eTravo. Reliable office transport, employee pickup and drop, executive travel, and business commute solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/130.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestcabserviceforcorporateemployeepune;